import { ReactNode } from 'react';
import { Button, Content, H2, Stack, Text } from '@kinesis/bungle';
import { Center } from '@/components/center';
import { KinesisLogo } from '@/components/kinesis-logo';

// The non-form faces of the claim screen: claimed, already claimed, expired,
// not found, "accept your invitation first", and "log in to continue".
const ShareMessage = (props: ShareMessageProps) => {
  const { title, children, action } = props;
  return (
    <Content background='white' borderRadiusSize='large' width={304}>
      <Content padding='large' sizing='fill-container' paddingMode='equal'>
        <Stack space='medium'>
          <Center>
            <KinesisLogo />
          </Center>
          <Center>
            <H2>{title}</H2>
          </Center>
          <Text>{children}</Text>
          {action && (
            <Button display='block' onClick={action.onClick}>
              {action.label}
            </Button>
          )}
        </Stack>
      </Content>
    </Content>
  );
};

export type ShareMessageProps = {
  title: string;
  children?: ReactNode;
  action?: { label: string; onClick: () => void };
};

export { ShareMessage };
